/*
|--------------------------------------------------------------------------
| Vue Router Config
|--------------------------------------------------------------------------
*/
export default {
  mode: "hash",

  linkActiveClass: "is-active",

  linkExactActiveClass: "is-current"
};
